import React, { useState } from 'react';
import { SectionWrapper } from './Shared';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQSection = () => {
  const faqs = [{
    q: '¿Cuánto tiempo me quitará al día?',
    a: 'Menos de lo que pasas mirando redes sociales sin sentido.'
  }, {
    q: '¿Necesito gimnasio?',
    a: 'No, puedes realizar los movimientos básicos en casa o en un parque.'
  }, {
    q: '¿Tengo que dejar el café?',
    a: 'No, aprenderás a usarlo estratégicamente para que no dañe tu descanso.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un producto digital (Ebook PDF) de acceso inmediato para que empieces hoy mismo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper className="bg-dark-800 border-y border-white/5" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-tight text-center mb-12" data-id="element-47">
          Preguntas <span className="text-gold-500" data-id="element-48">Frecuentes</span>
        </h2>

        <div className="space-y-4" data-id="element-49">
          {faqs.map((faq, idx) => <div key={idx} className="bg-dark-900 border border-white/10 rounded-xl overflow-hidden" data-id="element-50">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-51">
                <span className="font-oswald text-xl text-white uppercase tracking-wide pr-8" data-id="element-52">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-gold-500 shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-53" />
              </button>

              <AnimatePresence data-id="element-54">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-55">
                    <div className="px-6 pb-6 text-zinc-400 text-lg" data-id="element-56">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
};